import { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/help-article.css";

const translations = {
    vi: {
        loading: "Đang tải bài viết...",
        error: "Không thể tải bài viết. Vui lòng thử lại sau.",
        errorTitle: "Lỗi!",
        back: "Quay lại danh sách",
        backShort: "Quay lại",
        update: "Cập nhật:",
    },
    en: {
        loading: "Loading article...",
        error: "Cannot load the article. Please try again later.",
        errorTitle: "Error!",
        back: "Back to list",
        backShort: "Back",
        update: "Updated:",
    },
    ko: {
        loading: "글을 불러오는 중...",
        error: "글을 불러올 수 없습니다. 나중에 다시 시도해주세요.",
        errorTitle: "오류!",
        back: "목록으로 돌아가기",
        backShort: "뒤로",
        update: "업데이트:",
    }
};

function HelpArticle({ lang = "vi" }) {
    const { postId } = useParams();
    
    const history = useHistory();
    const t = translations[lang] || translations.vi;
    
    const [article, setArticle] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchArticle = async () => {
            try {
                setLoading(true);
                setError(null);
                
                const response = await fetch(
                    `https://blog.hanbiro.vn/?rest_route=/wp/v2/posts/${postId}`
                );
                
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                
                const data = await response.json();
                
                setArticle(data);
            } catch (err) {
                console.error("Error fetching article:", err);
                setError(t.error);
            } finally {
                setLoading(false);
            }
        };

        if (postId) {
            fetchArticle();
        }
    }, [postId, t.error]);

    const handleBack = () => {
        if (lang === 'vi') history.push('/help-center');
        else history.push(`/${lang}/help-center`);
    };

    useEffect(() => {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = "https://blog.hanbiro.vn/wp-includes/css/dist/block-library/style.min.css";
        document.head.appendChild(link);

        return () => {
             // Optional: check if link exists before removing to avoid errors if unmount happens quickly? 
             // document.head.removeChild(link) throws if not child.
             if (link.parentNode) link.parentNode.removeChild(link);
        };
    }, []);

    if (loading) {
        return (
            <div className="container my-5">
                <div className="article-loading">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3">{t.loading}</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="container my-5">
                <div className="article-error">
                    <button onClick={handleBack} className="btn btn-outline-primary mb-4">
                        ← {t.backShort}
                    </button>
                    <div className="alert alert-danger" role="alert">
                        <h4 className="alert-heading">{t.errorTitle}</h4>
                        <p>{error}</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container my-5">
            {/* Back Button */}
            <div className="article-header mb-4">
                <button onClick={handleBack} className="btn-back">
                    <span className="back-icon">←</span>
                    <span className="back-text">{t.back}</span>
                </button>
            </div>

            {/* Article Content */}
            <article className="article-content">
                {/* Title */}
                {article?.title?.rendered && (
                    <h1 
                        className="article-title"
                        dangerouslySetInnerHTML={{ __html: article.title.rendered }}
                    />
                )}

                {/*  Information */}
                <div className="article-meta">
                    {article?.date && (
                        <span className="article-date">
                            {t.update} {new Date(article.date).toLocaleDateString(lang === 'ko' ? 'ko-KR' : lang === 'vi' ? 'vi-VN' : 'en-US')}
                        </span>
                    )}
                </div>

                {/* Main Content */}
                {article?.content?.rendered && (
                    <div 
                        className="article-body"
                        dangerouslySetInnerHTML={{ __html: article.content.rendered }}
                    />
                )}
            </article>
        </div>
    );
}

export default HelpArticle;
